import type { MisconceptionDefinition } from '../types';

/**
 * TAA — Argumentatie sub-registry.
 *
 * Misconcepties rond argumenten, standpunten, tegenargumenten en de
 * verwarring tussen feit/mening en argument. Alle entries gekoppeld
 * aan family `TAA-ARGUMENTATIE`.
 *
 * Onderdeel van de TAA-barrel-splitsing (juni 2026) ter beperking van
 * het corruptierisico van het oorspronkelijke 2.249-regels taa.ts.
 */
export const TAA_ARGUMENTATIE_MISCONCEPTIONS: MisconceptionDefinition[] = [{
  id: 'taa.arg-feit-als-argument',
  label: 'Feit verward met argument/standpunt',
  module: 'Taalbegrip',
  description: 'Leerling verwart een feit (objectieve uitspraak) met een argument of standpunt in een tekst.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-feit-als-standpunt',
  label: 'Denkt dat alleen feiten standpunt kunnen zijn',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat alleen feitelijke uitspraken een standpunt kunnen vormen, en mist meningen als standpunt.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-mening-als-argument',
  label: 'Mening of bijargument verward met hoofdargument',
  module: 'Taalbegrip',
  description: 'Leerling identificeert een bijargument of mening als het hoofdargument (of als standpunt) van een tekst.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-standpunt-als-argument',
  label: 'Standpunt of tegenargument verward met ondersteunend argument',
  module: 'Taalbegrip',
  description: 'Leerling rekent een standpunt of tegenargument mee als ondersteunend argument bij het tellen of selecteren van argumenten.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-tellen-te-weinig',
  label: 'Te weinig argumenten geteld',
  module: 'Taalbegrip',
  description: 'Leerling mist één of meer argumenten bij het tellen van het aantal argumenten in een tekst.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-geen-argument-herkend',
  label: 'Argumenten niet herkend',
  module: 'Taalbegrip',
  description: 'Leerling herkent maar één of geen argumenten in een tekst die er meerdere bevat.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-mening-als-sterk',
  label: 'Persoonlijke mening gezien als sterk argument',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een persoonlijke mening (zonder onderbouwing) een sterk argument is.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-voorbeeld-als-sterk',
  label: 'Enkel voorbeeld gezien als sterk argument',
  module: 'Taalbegrip',
  description: 'Leerling beschouwt een enkel anekdotisch voorbeeld als een sterk algemeen argument.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-uiterlijk-als-sterk',
  label: 'Mening over uiterlijk gezien als sterk argument',
  module: 'Taalbegrip',
  description: 'Leerling verwart een subjectieve mening over uiterlijk of smaak met een sterk inhoudelijk argument.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-argument-als-tegenargument',
  label: 'Ondersteunend argument verward met tegenargument',
  module: 'Taalbegrip',
  description: 'Leerling identificeert een ondersteunend argument (of het standpunt zelf) als tegenargument, of omgekeerd.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-bijargument-als-tegenargument',
  label: 'Bijargument verward met tegenargument',
  module: 'Taalbegrip',
  description: 'Leerling identificeert een ondersteunend bijargument als tegenargument.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}, {
  id: 'taa.arg-samenvatting-als-tegenargument',
  label: 'Samenvatting of weerlegging verward met tegenargument',
  module: 'Taalbegrip',
  description: 'Leerling identificeert een samenvatting, conclusie of weerlegging als tegenargument, of mist de positie van een tegenargument in een betoog.',
  typicalFamilies: ['TAA-ARGUMENTATIE']
}];